import React from 'react';
import { Link } from 'react-router-dom';

export default function WhatsAppSuccess() {
  return (
    <div className="WhatsAppPage WhatsAppSuccess">
      <div className="page-content text-center">
        <img src={require('../../../assets/elfo-mascot-logo.png')} alt="..." />
        <h3 style={{ marginBottom: 8 }}>Thank you for reaching out!</h3>
        <p>
          Thank you for choosing elfoA2P! Next, one of our elfoA2P experts will contact you soon to
          discuss your business needs.
        </p>
        <p>
          Alternatively, you can reach out directly to the expert at
          <a href="mailto:elfoa2psupport@elfo.com">elfoa2psupport@elfo.com</a>. We look forward to
          speaking with you soon!
        </p>
        <Link className="btn btn-primary" to="/" style={{ minWidth: 160 }}>
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
